module.exports = __webpack_public_path__ + "static/media/down-arrow.d2b75d0d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/suttonparkbus/down-arrow.svg
// module id = 872
// module chunks = 0